import { MainContainer } from '@/components';
import { useInviteToken } from '@/components/auth/useInviteToken';
import { recheckProcessTranslation } from '@/helpers/recheckProcessTranslation';
import { useTranslation } from '@/hooks';
import { useGetAccountWithTokenQuery } from '@/services/accounts';
import { Box, Button } from '@palmetto/palmetto-components';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Account, ApplicantType } from 'types';

import PageHeader from '../PageHeader';

export const getPrimaryApplicant = (account: Account) => {
  if (!account) return null;
  return account.applicants?.find((applicant) => applicant.type === ApplicantType.primary);
};

export function SalesRepAuthentication() {
  const { id } = useParams<{ id: any }>();
  const { inviteToken } = useInviteToken();
  const { translate } = useTranslation();

  const { data: account, isLoading: isAccountLoading } = useGetAccountWithTokenQuery({
    id,
    inviteToken,
  });

  const handleClick = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append('state', JSON.stringify({ returnTo: window.location.href, inviteToken }));
    queryParams.append('inviteToken', inviteToken || '');

    const url = `/api/accounts/${account?.id}/sales-rep-verification/verify?${new URLSearchParams(queryParams)}`;
    window.location.assign(url);
  };

  return (
    <>
      <Helmet>
        <title>{translate('verifyIdentity', recheckProcessTranslation)}</title>
      </Helmet>
      <MainContainer>
        <Box width="50">
          <PageHeader
            title={`${translate('hello', recheckProcessTranslation)}${account?.salesRepName ? `, ${account.salesRepName}` : ''}`}
          />
          <Box gap="lg">
            <Box
              fontSize={{
                base: 'sm',
                tablet: 'md',
                desktop: 'lg',
              }}
              color="body-secondary"
            >
              {translate('onboardingSalesRep', recheckProcessTranslation)}
            </Box>
            {account && (
              <Box>
                <Box fontWeight="bold">{translate('yourEmail', recheckProcessTranslation)}</Box>
                <Box>{account?.salesRepEmail}</Box>
              </Box>
            )}
            <Box width={{ base: '100', tablet: '25' }}>
              <Button onClick={handleClick} disabled={isAccountLoading || !account}>
                {translate('verifyIdentity', recheckProcessTranslation)}
              </Button>
            </Box>
          </Box>
        </Box>
      </MainContainer>
    </>
  );
}
